import api from '../api'; // your configured axios instance
import axios from 'axios';
import { API_URL } from '../config';

export const getMyProfile = async () => {
  const response = await api.get('/me');
  return response.data;
};

export async function getWorkforceFlow(office) {
  try {
    const params = {};
    if (office) params.office = office;
    const response = await api.get('/employees/workforce-flow', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching workforce flow:', error);
    throw error;
  }
}

export const getMyImage = async () => {
  const response = await api.get('/employees/myImage', {
    responseType: 'blob', // 👈 Critical!
  });
  return URL.createObjectURL(response.data); 
};

export const getAllEmployees = async () => {
  const response = await api.get('/employees');
  return response.data;
};

export const getAll = async () => {
  const response = await api.get('/all-emps');
  return response.data;
};

export const getInterviewers = async () => {
  const response = await api.get('/interviewers');
  return response.data;
}


// Fetch ITs
export const getITs = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/employees/it`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined
  });
  return response.data;
};

// Register a new employee
export async function registerEmployee(employeeData) {
  try {
    const response = await api.post('/employees/register', employeeData);
    return response.data;
  } catch (error) {
    console.error('Error registering employee:', error);
    throw error;
  }
}

// Update an employee
export async function updateEmployee(employeeId, employeeData) {
  try {
    const response = await api.put(`/employees/${employeeId}`, employeeData);
    return response.data;
  } catch (error) {
    console.error('Error updating employee:', error);
    throw error;
  }
}

// Update employee overtime
export async function updateOvertime(employeeId, overtime) {
  try {
    const response = await api.post(
      `/employee/${employeeId}/adjustments`, 
      overtime,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding overtime:', error);
    throw error;
  }
}

// Delete an employee
export async function deleteEmployee(employeeId) {
  try {
    const response = await api.delete(`/employees/${employeeId}`);
    return response.data || true;
  } catch (error) {
    console.error('Error deleting employee:', error);
    throw error;
  }
}

// Reports APIs
export const getAllDepartments = async () => {
  const response = await api.get('/employees/departments');
  return response.data;
};

export const getEmployeeStatistics = async () => {
  const response = await api.get('/employees/statistics');
  return response.data;
};

// Employees goals metrics APIs 
export const getEmployeeCountByPositionPerOffice = async () => {
  try {
    const response = await api.get('/employees/position-count-by-office');
    return response.data;
  } catch (error) {
    console.error('Error fetching employee count by position per office:', error);
    throw error;
  }
};

export const getEmployeeCountByOffice = async () => {
  try {
    const response = await api.get('/employees/count-by-office');
    return response.data;
  } catch (error) {
    console.error('Error fetching employee count by office:', error);
    throw error;
  }
};

export const getAllInactiveEmployees = async () => {
  try {
    const response = await api.get('/inactive');
    return response.data;
  } catch (error) {
    console.error('Error fetching inactive employee ', error);
    throw error;
  }
}; 

export async function getInactiveEmployeeById(employeeId) {
  try {
    const response = await api.get(`/inactive//${employeeId}`);
    return response.data;
  } catch (error) {
    console.error('Error updating employee:', error);
    throw error;
  }
}